// extracted by mini-css-extract-plugin
export default {"main":"BodyMain_main__QfH1s","projects":"BodyMain_projects__1ZQp9"};